import { StatusDecorator} from '../UnifyAdministration/Notification/Blocks/StatusDecorator';
import {
  dateTimeComparatorAgGrid,
  valueFormatterAgGrid,
  dateValueFormatterWOTime,
  dateTimeValueFormatter,
} from '../UnifyAdministration/utils';
import { CustomStatusRenderer } from '../UnifyAdministration/renderer';
import { CustomLinkDeleteRenderer } from '../UnifyAdministration/Notification/Blocks/CustomDeleteRenderer';
import { Button, BUTTON_VARIANTS, IconContentCopy } from 'cdk-radial';

export const defaultColDef = {
  enablePivot: true,
  sortable: true,
  filter: true,
  flex: 1,
  autoHeight: true,
  minWidth: 100,
  resizable: true,
  refreshCells: true,
  headerHeight: '150px',
};

export const excelConfig = {
  excelStyles: [
    {
      id: 'header',
      font: {
        bold: true,
        size: 15,
      },
      interior: {
        color: '#bbb4bb',
        pattern: 'Solid',
      },
    },
  ],
  fileName: 'LINK_' + new Date().toJSON().slice(0, 10),
  allColumns: true,
  processCellCallback: function ({ column, value }: any) {
    return StatusDecorator(column.colId, value);
  },
};

export const getColumnDefs = (permissions: any, applications: any, workflows: any, archiveSwitch: any, t: Function) => {
  let columnDefinition = [
    {
      field: 'name',
      headerName: t('linksAdmin.colName'),
      cellClass: 'formattedColumn',
    },
    {
      field: 'description',
      headerName: t('linksAdmin.colDescription'),
      cellClass: 'formattedColumn',
    },
    {
      field: 'url',
      headerName: t('linksAdmin.colUrl'),
      cellClass: 'formattedColumn',
    },
    {
      field: 'target.department',
      headerName: t('linksAdmin.colTargetDepartment'),
      cellClass: 'formattedColumn',
    },
    {
      cellRenderer: (params: any) =>
        dateValueFormatterWOTime(params.data.startDate),
      field: 'startDate',
      headerName: t('linksAdmin.colStartDate'),
      sortable: true,
      cellClass: 'formattedColumn',
      filterParams: {
        comparator: (dateTimeInput: any, cellValue: any) => dateTimeComparatorAgGrid(dateTimeInput, cellValue),
        valueFormatter: (params: any) => valueFormatterAgGrid(params),
      },
    },
    {
      cellRenderer: (params: any) =>
        dateValueFormatterWOTime(params.data.endDate),
      field: 'endDate',
      headerName: t('linksAdmin.colEndDate'),
      sortable: true,
      cellClass: 'formattedColumn',
      filterParams: {
        comparator: (dateTimeInput: any, cellValue: any) => dateTimeComparatorAgGrid(dateTimeInput, cellValue),
        valueFormatter: (params: any) => valueFormatterAgGrid(params),
      },
    },
    {
      field: 'createdBy',
      headerName: t('linksAdmin.colCreatedBy'),
      cellClass: 'formattedColumn',
    },
    {
      field: 'createdOn',
      headerName: t('linksAdmin.colCreatedOn'),
      sortable: true,
      cellClass: 'formattedColumn',
      valueFormatter: (params: any) => dateTimeValueFormatter(params.value),
    },
    {
      field: 'lastUpdatedBy',
      headerName: t('linksAdmin.colLastUpdatedBy'),
      cellClass: 'formattedColumn',
    },
    {
      field: 'lastUpdatedOn',
      headerName: t('linksAdmin.colLastUpdatedOn'),
      sortable: true,
      cellClass: 'formattedColumn',
      valueFormatter: (params: any) => dateTimeValueFormatter(params.value),
    },
    {
      field: 'active',
      cellRenderer: (params: any) => (
        <CustomStatusRenderer isActive={params.data.active} startDate={params.data.startDate} />
      ),
      headerName: t('linksAdmin.colStatus'),
      sortable: true,
      colId: 'Status',
    },
    {
      colId: 'Duplicate',
      cellRenderer: (params: any) => <Button
        title="Copy"
        icon={<IconContentCopy />}
        text="Duplicate"
        variant={BUTTON_VARIANTS.ICON}
        onClick={""}
      />,
      sortable: true
    },
    {
      colId: 'Delete',
      cellRenderer: (params: any) => <CustomLinkDeleteRenderer />,
      sortable: true,
      getQuickFilterText: (params: any) => {
        return '';
      },
    }
  ];

  if (archiveSwitch === true) {
    columnDefinition = columnDefinition.filter((col) => col.colId !== 'Status' && col.colId !== 'Duplicate' && col.colId !== 'Delete');
  }


  return columnDefinition;
};